import { z } from 'zod';

const addressSchema = z.object({
  street: z.string().min(1, 'Street Name is required'),
  city: z.string().min(1, 'City is required'),
  state: z.string().min(1, 'State is required'),
  postcode: z.string().min(1, 'Postal Code is required'),
  country: z.string().min(1, 'Country is required'),
});

const assetSchema = z.object({
  name: z.string().min(1, 'Title is required'),
  owner: z.number({ required_error: 'Owner is required' }),
  organisation: z.number({
    required_error: 'Organisation is required, you may not have an organisation with sufficient permissions to create an asset',
  }),
  address: addressSchema,
  description: z.string().nullable(),
});

export default assetSchema;
